export default "__VITE_ASSET__CYMgNuDC__"